import { createFileRoute, redirect } from "@tanstack/react-router";

// Preserve indexed URLs and existing bookmarks.
export const Route = createFileRoute("/tica-hoy")({
  beforeLoad: () => {
    throw redirect({ to: "/tiempos-tica-hoy", statusCode: 301 });
  },
});
